import React, { useState, useEffect } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";

const PrivateRoutes = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("authToken");

    if (token) {
      axios
        .get("https://365luxuryhomes.com/api/admin/dashboard", {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          setUser(response.data.user); // Set user on successful API response
        })
        .catch((error) => {
          console.error("Error fetching user:", error);

          // Check if the error is due to token expiration
          if (error.response && error.response.status === 401) {
            localStorage.removeItem("authToken"); // Clear the token
            setUser(null);
          }
        })
        .finally(() => {
          setLoading(false); // Stop loading once the API call finishes
        });
    } else {
      setLoading(false); // Stop loading if no token
    }
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to={"/login"} />;
  }

  return children;
};

export default PrivateRoutes;
